<template>
  <div id="service">
    <div class="service-left">服务<br />成果</div>
    <div class="service-right">
      <div class="service-info">
        <img src="../../assets/image/service_2.png" alt="" />
        <div>
          <span>
            <animated-number
              :value="audience"
              :formatValue="formatToPrice"
              :duration="350"
            /> </span
          >万
        </div>
        <p>专业观众</p>
      </div>
      <div class="service-info">
        <img src="../../assets/image/service_2.png" alt="" />
        <div>
          <span>
            <animated-number
              :value="area"
              :formatValue="formatToPrice"
              :duration="400" /></span
          ><span class="unit">+</span>万平
        </div>
        <p>展览面积</p>
      </div>
      <div class="service-info">
        <img src="../../assets/image/service_2.png" alt="" />
        <div>
          <span>
            <animated-number
              :value="exhibition"
              :formatValue="formatToPrice"
              :duration="450"
            /> </span
          ><span class="unit">+</span> 场
        </div>
        <p>专业展会</p>
      </div>
    </div>
  </div>
</template>
<script>
import AnimatedNumber from "animated-number-vue";
import { configMixin } from "../../core/mixins/config.mixin";

export default {
  name: "page-serve",
  components: {
    AnimatedNumber,
  },
  mixins: [configMixin],
  methods: {
    formatToPrice(value) {
      return `${value.toFixed(0)}`;
    },
  },
};
</script>
<style lang="scss" scoped>
#service {
  display: flex;
  background: #4d4d4d;
  color: #fff;
  min-height: 75px;
  .service-left {
    width: 375px;
    height: 98px;
    background: #186bb5;
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    font-size: 22px;
    color: #ffffff;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .service-right {
    display: flex;
    flex: 3;
    justify-content: space-evenly;
    align-items: center;
    .service-info {
      font-size: 11px;
      text-align: center;
      span {
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: 400;
        font-size: 20px;
        color: #ffffff;
      }
    }
  }
}
</style>